import { metallicPalette } from './colors';

export const COLOR_PRESETS = [
  { id: 'slate', name: 'Metallic Slate', main: '#475569', dark: '#334155', light: '#64748B', lighter: '#F1F5F9', darker: '#1E293B' },
  { id: 'sapphire', name: 'Sapphire Blue', main: '#2563EB', dark: '#1D4ED8', light: '#60A5FA', lighter: '#EFF6FF', darker: '#1E40AF' },
  { id: 'emerald', name: 'Emerald Teal', main: '#0D9488', dark: '#0F766E', light: '#2DD4BF', lighter: '#F0FDF4', darker: '#115E59' },
  { id: 'amethyst', name: 'Royal Amethyst', main: '#7C3AED', dark: '#6D28D9', light: '#A78BFA', lighter: '#F5F3FF', darker: '#5B21B6' },
  { id: 'roseGold', name: 'Executive Rose', main: '#B76E79', dark: '#9A5560', light: '#D59AA3', lighter: '#FDF2F4', darker: '#7A3D46' }
];

export function getStoredThemeMode() {
  return localStorage.getItem('hrmsThemeMode') || 'light';
}

export function getStoredPresetColor() {
  return localStorage.getItem('hrmsPresetColor') || 'slate';
}

function hexToRgbString(hex) {
  const value = String(hex || '')
    .trim()
    .replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(value)) return '0,0,0';
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `${r},${g},${b}`;
}

export function applyGlobalThemeMode(mode, colorId) {
  const root = document.documentElement;
  const body = document.body;

  // 1. Mode Attribute
  root.setAttribute('data-theme', mode);
  root.setAttribute('data-color-scheme', mode);
  if (mode === 'dark') {
    body.classList.add('dark-mode');
    body.classList.remove('light-mode');
  } else {
    body.classList.add('light-mode');
    body.classList.remove('dark-mode');
  }

  // 2. Color Preset CSS Variables & Dynamic Object Update
  const preset = COLOR_PRESETS.find((p) => p.id === colorId) || COLOR_PRESETS[0];

  // Light mode keeps the selected preset; dark mode forces white accents across the app.
  const enforcedColor = mode === 'dark' ? '#FFFFFF' : preset.main;
  const enforcedDark = mode === 'dark' ? '#FFFFFF' : preset.dark || preset.main;
  const enforcedLighter = mode === 'dark' ? '#FFFFFF' : preset.lighter || preset.light || preset.main;

  root.style.setProperty('--primary-main', enforcedColor);
  root.style.setProperty('--primary-dark', enforcedDark);
  root.style.setProperty('--primary-darker', enforcedDark);
  root.style.setProperty('--primary-light', enforcedColor);
  root.style.setProperty('--primary-lighter', enforcedLighter);

  // Dynamically mutate metallicPalette so static references across components reflect enforced color
  metallicPalette.primary.main = enforcedColor;
  metallicPalette.primary.dark = enforcedDark;
  metallicPalette.primary.darker = enforcedDark;
  metallicPalette.primary.light = enforcedColor;
  metallicPalette.primary.lighter = enforcedLighter;

  // Keep layout chrome aligned with the active preset so shell surfaces can follow the theme.
  root.style.setProperty('--layout-primary', enforcedColor);
  root.style.setProperty('--layout-primary-rgb', hexToRgbString(enforcedColor));

  // Save preference
  localStorage.setItem('hrmsThemeMode', mode);
  localStorage.setItem('hrmsPresetColor', colorId);

  // Sync Mantis config context local storage key so MUI theme provider re-evaluates
  try {
    const rawConfig = localStorage.getItem('mantis-react-free-config');
    if (rawConfig) {
      const parsed = JSON.parse(rawConfig);
      parsed.presetColor = colorId;
      localStorage.setItem('mantis-react-free-config', JSON.stringify(parsed));
    }
  } catch (e) {
    // Ignore JSON errors
  }

  // Notify components and force re-render across UI
  window.dispatchEvent(new CustomEvent('hrmsThemeChanged', { detail: { mode, colorId, preset } }));
}
